import React from 'react';
import PropTypes from 'prop-types';
import './userCard.scss';

import { ReactComponent as AvatarIcon } from '../../../../assets/images/movies/avatar.svg';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const UserCard = ({ accountName, phoneOrEmail, avatarLink, isSelected, handler, isCurrent }) => {
  const { t } = useTranslation();
  return (
    <button className={classNames('choose_user_card', isSelected && 'selected')} onClick={handler}>
      <span className={classNames('choose_user_card__radio-btn', isSelected && 'selected')} />
      <span className={classNames('choose_user_card__avatar', isSelected && 'selected')}>
        {avatarLink ? (
          <img src={avatarLink} alt={accountName || 'avatar'} />
        ) : (
          <>{accountName?.charAt(0).toUpperCase() || <AvatarIcon />}</>
        )}
      </span>
      <span className="choose_user_card__text-wrapper">
        <span className="choose_user_card__name">{accountName}</span>
        <span className="choose_user_card__phone">{phoneOrEmail}</span>
        {isCurrent ? (
          <span className="choose_user_card__is-active">{t('auth.loginForm.current')}</span>
        ) : null}
      </span>
    </button>
  );
};

UserCard.propTypes = {
  accountName: PropTypes.string,
  phoneOrEmail: PropTypes.string,
  avatarLink: PropTypes.string,
  isSelected: PropTypes.bool,
  isCurrent: PropTypes.bool,
  handler: () => {}
};

export default UserCard;
